import log from '../../core/log';
// import waitForImages from 'jquery.waitforimages';
import { animate } from '../../core/animations';
import FilteringMenu from './FilteringMenu';
import { saveFilterState, applyFilterState, getSortingState, getPaginationState } from './filterState';
import productTileTemplate from './productTileTemplateNosto';
import keepSameHeightTitles from './keepSameHeightTitles';
import NostoCollections from '../../components/nosto/collections';
// import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
// import loadCachedColorFamilies from '../../components/data-caching/loadCachedColorFamilies';
import SuggestionsSearch from '../../components/overlay-search-nosto/suggestions-search';
import noResults from './noResults';
import recommendationListVisibility from './recommendationListVisibility';

let fm = null;
let collection_handle = '';
let collection_id = 0;
let products_json = null;
let filtered_products = [];
let filtered_products_search = [];
let filtered_products_paginated = [];
let per_page = Number(window.theme.collections.products_per_page);
// ASTR pagination (different from the Nosto pagination that starts at 0)
let current_page = 1;
let current_page_search = 1;
let current_total_products_shown = 0;
let current_total_products_shown_search = 0;
let nosto_nbHits = 0;
let nosto_nbHits_search = 0;
let NostoCollectionsObj = null;

/* *** For search overlay ***/
const setFilteredProducts = (new_filtered_products) => {
  filtered_products_search = new_filtered_products;
};

const setNextPageSearch = (reset = false) => {
  current_page_search = (reset) ? 1 : current_page_search + 1;
};

const setNbHitsSearch = (new_nosto_nbHits_search) => {
  nosto_nbHits_search = new_nosto_nbHits_search;
};

const setCurrentPageSearch = (new_current_page_search) => {
  current_page_search = new_current_page_search;
  window.theme.search.page = current_page_search;
};

const getCurrentPageSearch = () => {
  return current_page_search;
};

const getCurrentPage = () => {
  return current_page;
};

/* *** End search overlay compatibility ****/

const initMobilePagination = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';
  const f_page = (from_search) ? current_page_search : current_page;
  const f_nosto_nbHits = (from_search) ? nosto_nbHits_search : nosto_nbHits;

  const mobile_pagination = document.querySelector(`[data-${prefix}mobile-pagination]`);
  if (mobile_pagination) {
    mobile_pagination.classList.remove('disabled');
  }

  const pagination_first = document.querySelector(`[data-${prefix}pagination-first]`);
  const pagination_previous = document.querySelector(`[data-${prefix}pagination-previous]`);
  const pagination_last = document.querySelector(`[data-${prefix}pagination-last]`);
  const pagination_next = document.querySelector(`[data-${prefix}pagination-next]`);

  if (pagination_first) pagination_first.classList.remove('disabled');
  if (pagination_previous) pagination_previous.classList.remove('disabled');
  if (pagination_last) pagination_last.classList.remove('disabled');
  if (pagination_next) pagination_next.classList.remove('disabled');

  if (f_page <= 1) {
    if (pagination_first) pagination_first.classList.add('disabled');
    if (pagination_previous) pagination_previous.classList.add('disabled');
  }

  const total_pages = Math.ceil(f_nosto_nbHits / per_page);
  if (f_page >= total_pages) {
    if (pagination_last) pagination_last.classList.add('disabled');
    if (pagination_next) pagination_next.classList.add('disabled');
  }

  const current_page_element = document.querySelector(`[data-${prefix}current-page]`);
  const total_pages_element = document.querySelector(`[data-${prefix}total-pages]`);

  if (current_page_element) current_page_element.innerHTML = f_page;
  if (total_pages_element) total_pages_element.innerHTML = total_pages;

  // log('current_page', current_page, 'total_pages', total_pages);
};

const updateLoadMoreButton = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';

  const load_more_button = document.querySelector(`[data-${prefix}load-more]`);
  if (load_more_button) {
    load_more_button.innerHTML = 'Load more';
    load_more_button.classList.remove('hide', 'loading');

    // const total_results = from_search ? window.theme.search.total_results : window.theme.collections.total_results;
    // const c_page = from_search ? current_page_search : current_page;

    // if (total_results <= per_page * c_page) {
    if (filtered_products_paginated.length < per_page) {
      load_more_button.classList.add('hide');
    }
  }
};

// We load another pagge when on desktop for a total of 2 x window.theme.collections.products_per_page products
// To optimize the initial load time / rendering
// one_more when the use manually clicks the load more button
const triggerNextPage = (one_more = true) => {
  if (window.theme.breakpoints.current !== 'mobile') {
    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = (from_search) ? 'overlay-search-' : '';

    if (!document.querySelector(`[data-${prefix}load-more]`).classList.contains('hide')) {
      document.querySelector(`[data-${prefix}load-more]`).click();
    }

    window.trigger_on_more_page = one_more;
  }
};

const buildProductTiles = (append_content, from_search = false) => {
  if (!filtered_products_paginated.length) {
    return;
  }

  const prefix = (from_search) ? 'overlay-search-' : '';

  try {
    // Moving from Lodash/JSX templates to JavaScript Template Literals
    const products_tiles_html = filtered_products_paginated.map((product) => productTileTemplate(product, {
      is_slider: false,
      is_simplified: false,
      has_swatches: true,
      has_quickview: true,
      is_search: from_search,
      is_lookbook: false
    })).join('');

    const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results] .grid') : document.querySelector('[data-product-tiles] .grid');

    if (grid_container) {
      (append_content) ? grid_container.insertAdjacentHTML('beforeend', products_tiles_html) : grid_container.innerHTML = products_tiles_html;
    }
  } catch (error) {
    log(error);
  }

  if (!from_search) {
    const mobile_filter_nav = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
    if (mobile_filter_nav) {
      mobile_filter_nav.classList.add('active');
      mobile_filter_nav.parentElement?.classList.remove('visually-hidden');
    }
  
    document.querySelector('[data-total-filtered-items]')?.classList.remove('hide');
  }

  // const from_search = document.body.classList.contains('has-overlay-search');

  // Preselect the recommended color or 1st color swatch
  const tile_selector = from_search ? '[data-overlay-search-grid-container] [data-product-tile]' : '[data-collection-grid-container] [data-product-tile]';
  const init_tiles = Array.from(document.querySelectorAll(tile_selector)).filter(tile => !tile.classList.contains('init'));

  init_tiles.forEach(tile => {
    const color_swatch = tile.querySelectorAll('[data-color-swatch]');
    if (color_swatch.length > 0) {
      color_swatch[0].click();
    }
    tile.classList.add('init');
  });

  try {
    keepSameHeightTitles();
    animate();
    updateLoadMoreButton();
    initMobilePagination();
  } catch (error) {
    log(error);
  }

  // Dispatch events for new functionalities
  const tiles_built_event = new CustomEvent('astr-plp-tiles-built', { bubbles: true });
  tiles_built_event.data = { from_search, filtered: ($(`[data-${prefix}selected-filters-item]`).length > 0) };
  document.dispatchEvent(tiles_built_event);

  if (window.trigger_on_more_page === true) {
    triggerNextPage(false);
  }
};

// We're not using regular pagination anymore since Algolia might send out of stock pinned products which we remove later from applyAvailabilityFilter() and we end up with less than per_page products
const getNextSetOfProducts = (page_reset = true, load_page = false) => {
  // let total_pages = 1;
  // if (typeof load_page !== 'undefined') {
  //   total_pages = parseInt(load_page, 10);
  // }

  // const c_page = $('body').hasClass('has-overlay-search') ? current_page_search : current_page;
  const c_filtered_products = $('body').hasClass('has-overlay-search') ? filtered_products_search : filtered_products;
  let c_total_products_shown = 0;
  if (!page_reset) {
    c_total_products_shown = $('body').hasClass('has-overlay-search') ? current_total_products_shown_search : current_total_products_shown;
  }

  // const start = (c_page - 1) * per_page;
  // const end = (start + per_page) * total_pages;
  const start = c_total_products_shown;
  const end = c_filtered_products.length;
  if ($('body').hasClass('has-overlay-search')) {
    current_total_products_shown_search = c_filtered_products.length;
  } else {
    current_total_products_shown = c_filtered_products.length;
  }

  // log(current_page, start, end, per_page, load_page);
  // log('total returned', filtered_products.length);

  filtered_products_paginated = c_filtered_products.slice(start, end);

  log('getNextSetOfProducts', start, end, filtered_products_paginated, c_filtered_products.length);
};

// Refresh the items count and other misc options
const refreshOptions = (qty = filtered_products.length) => {
  let plural = 's';
  if (qty === 1) {
    plural = '';
  }

  let items_html = `${qty} item${plural}`;

  if ($('body').hasClass('template-search')) {
    const page_url = new URL(window.location.href);
    const search_params = new URLSearchParams(page_url.search);

    if (search_params.has('q')) {
      items_html = `${qty} result${plural} for "${search_params.get('q')}"`;
    }
  }

  $('[data-total-filtered-items]').html(items_html);

  initMobilePagination();
};

const scrollToTile = (save_filter_state) => {
  if (save_filter_state === false) {
    // Scroll to the last viewed product
    const previous_page = window.localStorage.getItem('previous-page') || '';

    if (previous_page.indexOf('/products/') !== -1) {
      const previous_page_parts = previous_page.split('/');
      const previous_product_parts = previous_page_parts[previous_page_parts.length - 1].split('?');
      const previous_product_handle = previous_product_parts[0];

      if ($(`[data-product-tile][data-product-handle="${previous_product_handle}"]`).length) {
        window.setTimeout(() => {
          // $('[data-products-load]').waitForImages(() => {  
            $('html, body').animate({ scrollTop: $(`[data-product-tile][data-product-handle="${previous_product_handle}"]`).offset().top - $('.shopify-section.header').outerHeight() + 20 }, 'slow');
          // });
        }, 500);
      }
    }
  } else {
    // $('html, body').animate({ scrollTop: $('[data-products]').offset().top - $('.shopify-section.header').outerHeight() + 20 }, 'slow');
  }
};

const getSelectedFilters = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';

  let selected_filtering = [];
  document.querySelectorAll(`[data-${prefix}filter-options]`).forEach(option => {
    const active_options = option.querySelectorAll('[data-clickable-option].active');
    
    if (active_options.length) {
      const group_type = (from_search) ? option.dataset.overlaySearchFilterOptionsType : option.dataset.filterOptionsType;
      
      active_options.forEach(active_option => {
        selected_filtering.push([
          group_type, 
          active_option.dataset.optionValue
        ]);
      });
    }
  });
  
  // Remove duplicates due to desktop/mobile filters
  selected_filtering = _.uniqWith(selected_filtering, _.isEqual);
  // selected_filtering_names = _.uniqWith(selected_filtering_names, _.isEqual);

  // Third level URL tag - /collections/whats-new/blue
  if (!from_search) {
    const custom_filter_color = window.localStorage.getItem('wild-third-level-url');
    if (custom_filter_color !== '' && custom_filter_color !== null) {
      // selected_filtering.push(['options.color', custom_filter_color]);
      const all_color_filters = custom_filter_color.split(',');
      for (let i = 0; i < all_color_filters.length; i++) {
        selected_filtering.push(['skus.customFields.astr-color_family', all_color_filters[i]]);
      }
    }
  }

  // log('[ASTR] selected_filtering', selected_filtering);

  return selected_filtering;
};

/**
 * Select a new filter / sorting option from the nav
 * force_per_page used when coming back from the PDP
 */
const selectNewFilter = async (save_filter_state = true, new_search = true, saved_page) => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';
  const is_save_filter_state = (from_search) ? false : save_filter_state;

  if (from_search) {
    current_page_search = 1;
  } else {
    current_page = 1;
  }

  if (is_save_filter_state) {
    saveFilterState();
  }

  if (!from_search && typeof saved_page !== 'undefined') {
    log(`[wild-filter] saved_page: ${saved_page}`);
    current_page = saved_page;

    if (current_page <= 0) {
      current_page = 1;
    }
  }

  // Extract the selected options
  const selected_filtering = getSelectedFilters();

  // Restore the sort by state
  document.querySelector(`[data-${prefix}sort-by] [data-value="${window.theme.collections.sorting}"] input`).checked = true;
  document.querySelector(`[data-mobile-${prefix}filter-sorting] [data-value="${window.theme.collections.sorting}"] input`).checked = true;

  recommendationListVisibility(selected_filtering);

  const grid_container_selector = from_search ? '[data-overlay-search-grid-container] .grid' : '[data-product-tiles] .grid';
  const grid_container = document.querySelector(grid_container_selector);
  if (grid_container) {
    grid_container.innerHTML = '';
  }

  if (new_search) {
    // Load the 1st page of Nosto data. It will be used as reference.
    let nosto_collection = null;

    if (from_search) {
      window.theme.search.filtering = selected_filtering;
      window.theme.search.page = 1;

      const suggestionsSearch = new SuggestionsSearch();
      await suggestionsSearch.nostoSearch(true);
      return;
    } else {
      const load_more_button = document.querySelector('[data-load-more]');
      if (load_more_button) {
        load_more_button.classList.add('hide');
      }

      window.theme.collections.filtering = selected_filtering;
      window.theme.collections.page = 1;

      nosto_collection = await NostoCollectionsObj.nostoRequest();
    }
    
    let nosto_products = [];

    if (typeof nosto_collection === 'undefined' || nosto_collection === null || typeof nosto_collection.products === 'undefined' || nosto_collection.products === null || nosto_collection.products.hits === null || nosto_collection.products.hits.length === 0) {
      // if (from_search) {
      //   filtered_products_search = [];
      // } else {
        filtered_products = [];
      // }
      
      refreshOptions(0);
    } else {
      nosto_products = nosto_collection.products.hits;

      // Load the same products from the Storefront API
      // const unique_ids = _.uniq(nosto_products.map(hit => hit.id));
      // const storefrontapi_products = await loadProductsByID(unique_ids);

      // log('-- Total Storefront API products:', storefrontapi_products.length);
      // log('-- Total Nosto hits:', nosto_products.length);

      // filtered_products = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
      if (from_search) {
        nosto_nbHits_search = nosto_collection.products.total;
      } else {
        nosto_nbHits = nosto_collection.products.total;
        refreshOptions(nosto_nbHits);
      }
    }

    if (from_search) {
      filtered_products_search = nosto_products;
    } else {
      filtered_products = nosto_products;
    }

    const mobile_filter_nav = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
    if (mobile_filter_nav) {
      mobile_filter_nav.classList.add('active');
    }

    const total_filtered_items = document.querySelector('[data-total-filtered-items]');
    if (total_filtered_items) {
      total_filtered_items.classList.remove('hide');
    }
  }

  const c_filtered_products = (from_search) ? filtered_products_search : filtered_products;

  if (c_filtered_products.length || !new_search) {
    // Show the correct amount of products
    if (is_save_filter_state === false && !from_search) {
      const load_page = getPaginationState();
      getNextSetOfProducts(true, load_page);
      current_page = load_page;
    } else {
      getNextSetOfProducts(true);
    }

    buildProductTiles(false, from_search);
  } else {
    noResults();
  }

  scrollToTile(is_save_filter_state);

  if (per_page > window.theme.collections.products_per_page) {
    current_page = per_page / window.theme.collections.products_per_page;
    per_page = window.theme.collections.products_per_page;
  }

  // Load one more page if on desktop
  triggerNextPage(false);
};

/**
 * Load the original collection data. Either on first call or when a sorting event occurs
 */
const loadCollection = async () => {
  try {
    if (collection_handle === null || !collection_handle.length) {
      return;
    }

    const from_search = document.querySelector('body').classList.contains('has-overlay-search');

    if (!window.theme.collections.page_split) {
      if (from_search) {
        const overlaySearchGridContainer = document.querySelector('[data-overlay-search-grid-container] .grid');
        if (overlaySearchGridContainer) {
          overlaySearchGridContainer.innerHTML = '';
        }
      } else {
        const collectionGridContainer = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
        if (collectionGridContainer) {
          collectionGridContainer.classList.remove('active');
        }
      
        const productTilesGrid = document.querySelector('[data-product-tiles] .grid');
        if (productTilesGrid) {
          productTilesGrid.innerHTML = '';
        }
      
        const loadMoreButton = document.querySelector('[data-load-more]');
        if (loadMoreButton) {
          loadMoreButton.classList.add('hide');
        }
      
        const totalFilteredItems = document.querySelector('[data-total-filtered-items]');
        if (totalFilteredItems) {
          totalFilteredItems.classList.add('hide');
        }
      }
    }

    window.theme.collections.sorting = getSortingState();

    // This function also gets called after selecting a new sorting option and filtering options might have been selected already
    // Extract the selected filter options
    const selected_filtering = getSelectedFilters();

    if (from_search) {
      window.theme.search.page = 1;
      window.theme.search.filtering = selected_filtering;
    } else {
      window.theme.collections.page = 1;
      window.theme.collections.filtering = selected_filtering;
    }

    log('[ASTR] Initial Sorting:', window.theme.collections.sorting);
    log('[ASTR] Initial Filtering:', selected_filtering);

    /*
    // Load the 1st page of Algolia data. Algolia data will be used as reference.
    const nosto_collection = await loadAlgoliaCollection(0, selected_filtering);
    let nosto_products = [];

    // Merge the cached data and the Algolia data if we received data from Algolia
    if (nosto_collection !== null && typeof nosto_collection.hits !== 'undefined' && nosto_collection.hits.length) {
      nosto_products = nosto_collection.hits;

      const unique_ids = _.uniq(nosto_products.map(hit => hit.id));

      const promises = [];
      // Load the same products from the Storefront API
      promises.push(loadProductsByID(unique_ids, false, false, false, false, false, false, true));

      // Load the color families cached by the colors app
      if (!window.theme.collections.color_families_all.length) {
        promises.push(loadCachedColorFamilies(window.theme.collections.color_families_file));
      }
      
      const result_promises = await Promise.all(promises);
      const storefrontapi_products = result_promises[0];

      if (!window.theme.collections.color_families_all.length) {
        window.theme.collections.color_families_all = result_promises[1];
      }

      log('-- Total Storefront API products:', storefrontapi_products.length);
      log('-- Total Algolia hits:', nosto_products.length);
      products_json = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);

      // Assign the color families linked to the collection
      if (!from_search) {
        const collection_attributes = _.find(window.theme.collections.data, { handle: window.theme.collections.current });

        log('collection_attributes.color_families', collection_attributes.color_families);
        if (typeof collection_attributes.color_families === 'undefined') {
          let color_options = algolia_collection.facets['options.color'];

          // Remove color prefix for plus size products
          if (is_plus) {
            color_options = Object.entries(color_options).reduce((acc, [color, count]) => {
              const cleanedColor = color.replace('Plus Size - ', '');
              acc[cleanedColor] = count;
              return acc;
            }, {});
          }

          collection_attributes.color_families = getColorFamiliesFromColorFacet(color_options);
          log('[ASTR] Collection color families', collection_attributes.color_families, color_options);
        }
      }
    }

    const start_rendering = new Date();

    // log('products_json', products_json);

    if (products_json !== null && products_json.length && nosto_products !== null && nosto_products.length) {
      window.theme.algolia.facets = nosto_collection.facets;

      // For some reasons, facets are ramdomly undefined, pause the script a bit
      // const pause_script = (millis) => new Promise((resolve) => {
      //   setTimeout(() => resolve(), millis);
      // });
      // await pause_script(50);

      if (fm === null) {
        // const fs_filter = (fs_collection !== null && typeof fs_collection.payload !== 'undefined' && typeof fs_collection.payload.facets !== 'undefined' && fs_collection.payload.facets.length) ? fs_collection.payload.facets : [];
        fm = new FilteringMenu(nosto_collection.facets);
        $('[data-filters-panel-v2]').addClass('loaded');
      }
      
      // filterJson();

      if (filtered_products.length) {
        // const load_page = getPaginationState();
        // getNextSetOfProducts(load_page);
        // current_page = load_page;
        getNextSetOfProducts(true);
        buildProductTiles(false, from_search);
      } else {
        noResults();
      }

      if (from_search) {
        nosto_nbHits_search = nosto_collection.nbHits;
        initMobilePagination();
      } else {
        nosto_nbHits = nosto_collection.nbHits;
        refreshOptions(nosto_nbHits);

        // When coming back from a product page - ONLY
        const apply_filters = await applyFilterState(true);
        if (!apply_filters) {
          selectNewFilter(false, false);
        }
      }

      const end_rendering = new Date() - start_rendering;
      log(`Data rendered in ${end_rendering / 1000} seconds`);
    } else {
      noResults();
      refreshOptions(0);

      // Hide the filters
      $('.collection-grid-section').addClass('no-results');
      $('[data-collection-grid-container] [data-show-mobile-filter-nav]').hide();

      if ($('[data-change-grid]').length) {
        $('[data-change-grid-parent]').hide();
      }
    }
    */

    // Load the color families cached by the colors app. Will be needed for the Colors filter
    // if (!window.theme.collections.color_families_all.length) {
    //   window.theme.collections.color_families_all = await loadCachedColorFamilies(window.theme.collections.color_families_file);
    // }

    const nosto_collection = await NostoCollectionsObj.nostoRequest();
    let nosto_products = [];

    if (typeof nosto_collection !== 'undefined' && nosto_collection !== null && typeof nosto_collection.products !== 'undefined' && nosto_collection.products !== null && nosto_collection.products.hits !== null && nosto_collection.products.hits.length > 0) {
      nosto_products = nosto_collection.products.hits;
    }

    const start_rendering = new Date();

    /*
    * We don't need to extract the color families or extract Shopify product data at this point, but keep for future reference
    *
    const unique_ids = _.uniq(nosto_products.map(hit => hit.id));

    const promises = [];
    // Load the same products from the Storefront API
    promises.push(loadProductsByID(unique_ids));

    // Load the color families cached by the colors app
    if (!window.theme.collections.color_families_all.length) {
      promises.push(loadCachedColorFamilies(window.theme.collections.color_families_file));
    }

    const result_promises = await Promise.all(promises);
    const storefrontapi_products = result_promises[0];

    if (!window.theme.collections.color_families_all.length) {
      window.theme.collections.color_families_all = result_promises[1];
    }

    log('-- Total Storefront API products:', storefrontapi_products.length);
    log('-- Total Nosto hits:', nosto_products.length);
    products_json = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
    */
    products_json = nosto_products;

    if (products_json === null || products_json.length === 0) {
      // if (!window.theme.collections.page_split) {
        noResults();
        refreshOptions(0);

        // Hide the filters
        $('.collection-grid-section').addClass('no-results');
        $('[data-collection-grid-container] [data-show-mobile-filter-nav]').hide();

        if ($('[data-change-grid]').length) {
          $('[data-change-grid-parent]').hide();
        }
      // }
    } else {
      window.theme.collections.facets = nosto_collection.products.facets ?? [];

      // getNextSetOfProducts(true);
      filtered_products = products_json;

      // Build the filter menu
      if (fm === null && window.theme.collections.facets.length > 0) {
        fm = new FilteringMenu();
        $('[data-filters-panel-v2]').addClass('loaded');
      }

      if (filtered_products.length) {
        getNextSetOfProducts(true);
        buildProductTiles(false, from_search);
      } else {
        noResults();
      }

      if (from_search) {
        nosto_nbHits_search = nosto_collection.products.total;
        initMobilePagination();
      } else {
        nosto_nbHits = nosto_collection.products.total;
        refreshOptions(nosto_nbHits);

        // When coming back from a product page - ONLY
        const apply_filters = await applyFilterState(true);
        // if (!apply_filters) {
        //   selectNewFilter(false, false);
        // }
      }

      const end_rendering = new Date() - start_rendering;
      log(`Data rendered in ${end_rendering / 1000} seconds`);
    }
    
    // Load one more page if on desktop
    triggerNextPage(false);
  } catch (error) {
    console.log('[ASTR] loadCollection()', error);
  }
};

/**
 * Request the new page data (From numbered pagination or load more)
 * Adds the products to the filtered_products variable
 *
 * @param {Boolean} regular_pagination - Numbered pagination if true; Load more if false
 *
 * @returns {Boolean} false if no Nosto products extracted. true otherwise
 * 
 */
const loadPageData = async (regular_pagination = false) => {
  const from_search = document.body.classList.contains('has-overlay-search');

  // Empty the page if on mobile
  if (window.theme.breakpoints.current === 'mobile') {
    const grid_container_selector = from_search ? '[data-overlay-search-results] .grid' : '[data-product-tiles] .grid';
    const grid_container = document.querySelector(grid_container_selector);
    if (grid_container) {
      grid_container.innerHTML = '';
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
    document.querySelector('[data-mobile-pagination]').classList.add('disabled');
  }

  // Extract the selected filter options
  const selected_filtering = getSelectedFilters();
  if (from_search) {
    window.theme.search.filtering = selected_filtering;
  } else {
    window.theme.collections.filtering = selected_filtering;
  }

  /*
  // Load and add the next set of Algolia products to filtered_products
  const nosto_collection = await loadAlgoliaCollection(current_page - 1, selected_filtering);
  let nosto_products = [];

  if (nosto_collection === null || typeof nosto_collection.hits === 'undefined' || nosto_collection.hits.length === 0) {
    return false;
  }

  // Merge the cached data and the Algolia data if we received data from Algolia
  nosto_products = nosto_collection.hits;

  // Load the same products from the Storefront API
  const unique_ids = _.uniq(nosto_products.map(hit => hit.id));
  const storefrontapi_products = await loadProductsByID(unique_ids);

  const new_set_of_filtered_products = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
  */

  const nosto_collection = await NostoCollectionsObj.nostoRequest();
  let nosto_products = [];

  if (typeof nosto_collection === 'undefined' || nosto_collection === null || typeof nosto_collection.products === 'undefined' || nosto_collection.products === null || nosto_collection.products.hits === null || nosto_collection.products.hits.length === 0) {
    return false;
  }

  nosto_products = nosto_collection.products.hits;

  if (regular_pagination) {
    filtered_products_paginated = nosto_products;
    filtered_products = nosto_products;
  } else {
    filtered_products = _.concat(filtered_products, nosto_products);
  }
  
  // log('[ASTR] -- Total Storefront API products:', storefrontapi_products.length);
  log('[ASTR] -- Total Nosto hits in page:', nosto_products.length);
  log('[ASTR] -- Total filtered products:', filtered_products.length);

  if (!from_search) {
    recommendationListVisibility(selected_filtering);
  }

  return true;
};

/**
 * Init the events for some of the elements within the PLP
 */
const initEvents = () => {
  // Load more for PLP only (not search overlay)
  document.addEventListener('click', async (e) => {
    if (e.target.matches('[data-load-more]')) {
      e.preventDefault();
      e.stopPropagation();
      const item = e.target;

      if (item.classList.contains('loading')) {
        return;
      }

      const from_search = document.body.classList.contains('has-overlay-search');
      item.innerHTML = 'Loading...';
      item.classList.add('loading');
      current_page++;
      (from_search) ? window.theme.search.page = current_page : window.theme.collections.page = current_page;
      saveFilterState();

      window.trigger_on_more_page = true;

      await loadPageData();
      getNextSetOfProducts(false);
      buildProductTiles(true, false);

      if (filtered_products_paginated.length < per_page) {
        const load_more_button = document.querySelector('[data-load-more]');
        if (load_more_button) {
          load_more_button.classList.add('hide');
        }
      }

      // [ADA] Focus new element, do not place the focus to the main element, it would enable the add to cart / quickview button
      // const last_tile_index = per_page * (current_page - 1);
      // document.querySelectorAll('[data-product-tile] [data-product-tile-image]')[last_tile_index].focus();
    }
  });

  /* ********************************************
  Mobile pagination PLP only (not search overlay)
  ******************************************** */
  // Helper function to handle pagination clicks
  const handlePaginationClick = async (item, pageChange) => {
    if (item.classList.contains('disabled')) {
      return;
    }

    const from_search = document.body.classList.contains('has-overlay-search');
    current_page += pageChange;
    const total_pages = Math.ceil(nosto_nbHits / per_page);
    current_page = Math.max(1, Math.min(current_page, total_pages));
    (from_search) ? window.theme.search.page = current_page : window.theme.collections.page = current_page;

    saveFilterState();
    initMobilePagination();
    await loadPageData(true);
    buildProductTiles(false, false);
    initMobilePagination();

    // [ADA] Focus new element
    document.querySelector('[data-product-tiles] [data-product-tile]').focus();
  };

  document.addEventListener('click', async (e) => {
    const target = e.target.closest('[data-pagination-first], [data-pagination-last], [data-pagination-next], [data-pagination-previous]');
  
    if (!target) return;

    if (target.matches('[data-pagination-first]')) {
      current_page = 1;
      await handlePaginationClick(target, 0);
    } else if (target.matches('[data-pagination-last]')) {
      const total_pages = Math.ceil(nosto_nbHits / per_page);
      current_page = total_pages;
      await handlePaginationClick(target, 0);
    } else if (target.matches('[data-pagination-next]')) {
      await handlePaginationClick(target, 1);
    } else if (target.matches('[data-pagination-previous]')) {
      await handlePaginationClick(target, -1);
    }
  });

  /*
  // Might not be the best place to add but this is for PLP and Search overlay
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-product-tile-image]')) {
      const item = e.target;
      const tile = item.closest('.product-tile');
      // algoliaSearchClickEvent([String(tile.dataset.productAlgoliaId)], [tile.closest('.product-tile').index() + 1]);
    }
  });
  */
};

/**
 * Initialize the events and data for filtering
 */
const initFiltering = async () => {
  try {
    // Validate and retrieve collection data
    const collection_grid = document.querySelector('[data-collection-grid]');
    if (!collection_grid) {
      throw new Error('Collection grid element not found.');
    }

    collection_handle = collection_grid.dataset.collection || '';
    collection_id = collection_grid.dataset.collectionId || '';

    if (!collection_handle || !collection_id) {
      throw new Error('Collection handle or ID is missing.');
    }

    // Initialize NostoCollections object
    NostoCollectionsObj = new NostoCollections(collection_id);
    if (!NostoCollectionsObj) {
      throw new Error('Failed to initialize NostoCollections.');
    }

    // Initialize events and load collection data
    initEvents();
    await loadCollection();
  } catch (error) {
    console.error('[initFiltering] Error initializing filtering:', error);
  }
};

export {
  initFiltering,
  selectNewFilter,
  scrollToTile,
  products_json,
  filtered_products,
  filtered_products_search,
  noResults,
  buildProductTiles,
  setFilteredProducts,
  setNextPageSearch,
  setNbHitsSearch,
  setCurrentPageSearch,
  getCurrentPageSearch,
  getCurrentPage,
  getNextSetOfProducts,
  getSelectedFilters,
  per_page,
  initMobilePagination,
  loadCollection,
};
